import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BaseWidget } from 'src/app/tools/abstract-classes/base-widget';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { Role } from 'src/app/assabil-kernel/models/entities/master-data/role-entity';
import { MasterDataService } from 'src/app/assabil-kernel/services/master-data-service';
import { RoleItinerary } from 'src/app/assabil-kernel/models/entities/master-data/role-itinerary-entity';


@Component({
    selector: 'role-widget',
    templateUrl: './role-widget.component.html',
    styleUrls: ['./role-widget.component.scss']
})

export class RoleWidgetComponent extends BaseWidget {
  
  role            : Role = new Role();

 //---------------------------------------------------------------------------------------
  constructor(
      protected toastr               : ToastrService,
      protected leanUtilsService     : LeanUtilsService,
      protected masterDataService    : MasterDataService) {
      super(toastr, leanUtilsService);

      this.entityName = "role";
  }
//---------------------------------------------------------------------------------------


//---------------------------------------------------------------------------------------
setEntity(role: Role) {
      this.role  = { ...role };
      this.role.roleItinerarys = [];
      if (role.roleItinerarys) {
        for (let roleItinerary of role.roleItinerarys) {
          this.role.roleItinerarys.push({ ...roleItinerary });
        }
      }
  }
//---------------------------------------------------------------------------------------

//---------------------------------------------------------------------------------------
ngAfterViewInit() {
  super.ngAfterViewInit();
  for(let field of this.childFields) {
    if (field.prop == 'itinerary') {
      field.modalParam  = this.role;  
    }
  }
}
//---------------------------------------------------------------------------------------
  
//---------------------------------------------------------------------------------------
  getEntity(){
    return this.role;
  }
//---------------------------------------------------------------------------------------


//----------------------------------------------------------------------
beforeValidate() : boolean{
  let pleaseFillField = "Priere de renseigner le champ : ";

  if (this.leanUtilsService.isBlank(this.role.roleCode)) {
    this.leanUtilsService.error(pleaseFillField + "Code");
    return false;
  }

  if (this.leanUtilsService.isBlank(this.role.name)) {
    this.leanUtilsService.error(pleaseFillField + "Nom");
    return false;
  }

  if ( (this.role.upRole == null) || (this.role.upRole.roleCode == null) ) {
    this.leanUtilsService.error(pleaseFillField + "Role Parent");
    return false;
  }

  if ( (this.role.branch == null) || (this.role.branch.branchCode == null) ) {
    this.leanUtilsService.error(pleaseFillField + "Agence");
    return false;
  }
  if ( (this.role.geoArea == null) || (this.role.geoArea.geoAreaCode == null) ) {
    this.leanUtilsService.error(pleaseFillField + "Région");
    return false;
  }

  if ( (this.role.profile == null) || (this.role.profile.profileCode == null) ) {
    this.leanUtilsService.error(pleaseFillField + "Profil");
    return false;
  }

  if  (! this.role.online) {
    if ( (this.role.warehouse == null) || (this.role.warehouse.warehouseCode == null) ) {
      this.leanUtilsService.error(pleaseFillField + "Dépôt");
      return false;
    }
    if ( (this.role.feededFromWarehouse == null) || (this.role.feededFromWarehouse.warehouseCode == null) ) {
      this.leanUtilsService.error(pleaseFillField + "Alimenté par Dépôt");
      return false;
    }
    if ( (this.role.feededFromWarehouse == null) || (this.role.feededFromWarehouse.warehouseCode == null) ) {
      this.leanUtilsService.error(pleaseFillField + "Alimenté par Dépôt");
      return false;
    }
    if ( (this.role.tokenSerie == null) || (this.role.tokenSerie.tokenSerieCode == null) ) {
      this.leanUtilsService.error(pleaseFillField + "Token Serie");
      return false;
    }
  }

  return true;
}

saveRow(): Promise<Role> {
  return this.masterDataService.roleSave(this.role);
}
//----------------------------------------------------------------------

//----------------------------------------------------------------------
new(){
  let roleItinerary : RoleItinerary = new RoleItinerary();
  roleItinerary.inserted = true;
  this.role.roleItinerarys.push(roleItinerary);
  this.role.roleItinerarys = [...this.role.roleItinerarys];
}
//----------------------------------------------------------------------

}
